<template src="@/templates/dashboard/charts/byImages.html"></template>

<script>
	import {commonFunctions} from "@/common/commonFunctions";
	
	export default {
		name: 'ByImages',
		props: ['boardContent', 'heightOffset'],
		data() {
			return {
				boards: [],
				builtHTML: '',
				showSpinner: true,
				chartHeight: 0,
				offset: 290
			}
		},
		created() {
			this.setViewHeight();
			this.buildHTML();
		},
		methods: {
			getWidthHeight() {
				let offset = -38.5;
				return "height:" + (this.chartHeight + offset)/2 + "px";
			},
			buildHTML(){
				// Initiate the html variable.
				this.boards = this.boardContent;
				
				// If it has a content
				if (this.boards.length > 0) {
					let thisComp = this;
					let tagProperties = '';
					let tagContent = '';
					let childTagContent = '';
					let childTagProperties = '';
					this.boards.forEach((board) => {
						tagProperties = commonFunctions.buildProperty(thisComp.$data, board.properties);
						tagContent = commonFunctions.buildContent(board.content);

						// Opening parent html tag including its properties and innerHTML.
						this.builtHTML += '<' + board.tag + ' ' + tagProperties + '>' + tagContent;


						if (board.childTags.length > 0) {
							// Child tag iteration.
							board.childTags.forEach((childTag) => {
								childTagProperties = commonFunctions.buildProperty(thisComp.$data, childTag.properties);
								childTagContent = commonFunctions.buildContent(childTag.content);

								// Opening child html tag including its properties, innerHTML and closing tag.
								this.builtHTML += '<' + childTag.tag + ' ' + childTagProperties + '>'
									+ childTagContent + '<\/' + childTag.tag + '>';
							});
						}

						// Closing tag of parent.
						this.builtHTML += '<\/' + board.tag + '>';
					});
					
				}
			},
			setViewHeight() {
				this.chartHeight = (window.innerHeight - (this.heightOffset > 0 ? this.heightOffset : this.offset));
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/charts/ByImages.vue